import { Link } from '@mui/material';
import React, { useRef, useState, useEffect } from 'react';
import { Row, Col, Card, Table, Button, Form, Modal } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import EditIcon from '@mui/icons-material/Edit';
import { Formik } from 'formik';
import * as yup from 'yup';
import DatePicker from 'react-multi-date-picker';
import moment from 'moment';
import { BiEditAlt } from 'react-icons/bi';
import { FaRegClone } from 'react-icons/fa';

//  ag grid
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { Tooltip } from 'antd';
import LdcApi from '../../LdcApis';
import { useToasts } from 'react-toast-notifications';
import dayjs from 'dayjs';
export const handleTime = (dataD) => {
  let data = new Date(dataD);
  let hrs = data.getHours();
  let mins = data.getMinutes();
  if (hrs <= 9) hrs = '0' + hrs;
  if (mins < 10) mins = '0' + mins;
  const postTime = hrs + ':' + mins;
  return postTime;
};
const userInfo = JSON.parse(localStorage.getItem('user_info'));
const validationSchema = yup.object().shape({
  // chamberDate: yup.string().required('  Date   is required'),
  chamberDate: yup
    .array()
    .of(yup.string().required('Date is required'))
    .min(1, 'Please select at least one date')
    .required('Date is required')
    .nullable(),
  roomId: yup.string().required('Room Name is required'),
});

const ChamberTable = ({
  chamberTableData,
  getChamberList,
  handleEditTableRow,
  name,
  role,
  roomList,
}) => {
  const { addToast } = useToasts();
  const gridRef = useRef();
  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [lastPayload, setLastPayload] = useState(null); // store payload for retry
  const [conflictDates, setConflictDates] = useState(null);
  console.log('chamberTableData', chamberTableData);

  // ag grid ***********************************
  const [modify, setModify] = useState({});
  const [show, setShow] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const bookedDates = new Set(chamberTableData.map((item) => item.chamberDate));
  const [initialValues, setInitialValues] = useState({
    ...modify,
    chamberDate: [],
  });

  const getFirstAvailableDate = (
    chamberTableData,
    doctorId,
    startFromDate = null
  ) => {
    // Get booked dates only for this doctor
    const bookedDates = new Set(
      chamberTableData
        .filter((item) => item.doctorId === doctorId)
        .map((item) => item.chamberDate)
    );

    // Start from today (not tomorrow)
    let date = startFromDate ? dayjs(startFromDate) : dayjs();

    for (let i = 0; i < 365; i++) {
      const formatted = date.format('YYYY-MM-DD');
      if (!bookedDates.has(formatted)) {
        return formatted; // first free date (today or later)
      }
      date = date.add(1, 'day'); // check next day
    }
    return null;
  };

  // const getFirstAvailableDate = (chamberTableData, doctorId, startFromDate = null) => {
  //   // Get booked dates only for this doctor
  //   const bookedDates = new Set(
  //     chamberTableData
  //       .filter(item => item.doctorId === doctorId)
  //       .map(item => item.chamberDate)
  //   );

  //   // Start from tomorrow or given reference date
  //   let date = startFromDate
  //     ? dayjs(startFromDate).add(1, "day")
  //     : dayjs().add(1, "day");

  //   for (let i = 0; i < 365; i++) {
  //     const formatted = date.format("YYYY-MM-DD");
  //     if (!bookedDates.has(formatted)) {
  //       return formatted;
  //     }
  //     date = date.add(1, "day");
  //   }
  //   return null;
  // };

  useEffect(() => {
    if (show) {
      const firstFree = getFirstAvailableDate(
        chamberTableData,
        modify.doctorId
      );

      setInitialValues({
        ...modify,
        chamberDate: [],
        // chamberDate: firstFree ? [firstFree] : [], 
      });
    }
  }, [show, modify, chamberTableData]);

  const handleCloneTableRow = (params) => {
    setShow(true);
    setModify(params.data);
  };
  const [columnDefs] = useState([
    {
      headerName: '',
      width: 90,
      maxWidth: 120,
      filter: false,
      hide:
        (userInfo && userInfo?.roleID == 8) || userInfo?.roleID == 9
          ? false
          : true,
      cellRenderer: function (params) {
        return (
          <div className='d-flex align-items-center mt-2 actions_ag_grid'>
            {/* {params.data.role !== 'Assistant' && ( */}
            <Tooltip placement='left' title='Edit'>
              <BiEditAlt
                className='mx-2 edit_btn'
                onClick={() => handleEditTableRow(params)}
                style={{
                  fontSize: '1.4rem',
                  cursor: 'pointer',
                }}
              />
            </Tooltip>
            <Tooltip placement='left' title='Clone'>
              <FaRegClone
                className='mx-2 edit_btn'
                onClick={() => handleCloneTableRow(params)}
                style={{
                  fontSize: '1.4rem',
                  cursor: 'pointer',
                }}
              />
            </Tooltip>
            {/* )} */}
          </div>
        );
      },
    },
    {
      headerName: 'Doctor',
      field: 'doctor',
      width: 100,
      minWidth: 100,
      cellRenderer: function (params) {
        return (
          <p
            className='  cursors head_td '
            style={{ textTransform: 'capitalize' }}
          >
            {params.value}
          </p>
        );
      },
    },
    {
      headerName: 'Date',
      field: 'chamberDate',
      width: 100,
      maxWidth: 120,
      cellRenderer: function (params) {
        return (
          <p className='ag_grid_caps cursors head_td '>
            {moment(new Date(params.value)).format('DD/MM/YYYY')}
          </p>
        );
      },
    },
    {
      headerName: 'Start Time',
      field: 'timeStart',
      width: 100,
      maxWidth: 100,
      cellRenderer: function (params) {
        return <p className='ag_grid_caps cursors head_td '>{params.value}</p>;
      },
    },
    {
      headerName: 'End Time',
      field: 'timeEnd',
      width: 100,
      maxWidth: 100,
      cellRenderer: function (params) {
        return <p className='ag_grid_caps cursors head_td '>{params.value}</p>;
      },
    },
    {
      headerName: 'Room',
      field: 'roomName',
      width: 100,
      maxWidth: 180,
      cellRenderer: function (params) {
        return <p className='ag_grid_caps cursors head_td '>{params.value}</p>;
      },
    },
    {
      headerName: 'Created By',
      field: 'userName',
      filter: false,
      sortable: false,
      floatingFilter: false,
      width: 100,
      minWidth: 100,
      cellRenderer: function (params) {
        return (
          <div className=''>
            <span>
              {params.data.userName} at{' '}
              {moment(new Date(params.data.createdOn)).format(
                'DD/MM/YYYY h:mm A'
              )}
            </span>
          </div>
        );
      },
    },
    {
      headerName: 'Status',
      field: 'active',
      filter: false,
      sortable: false,
      floatingFilter: false,
      width: 60,
      maxWidth: 100,
      cellRenderer: function (params) {
        return (
          <div className=''>
            <span
              className={`  ${params.data.active ? 'is_active' : 'in_active'}`}
            >
              {params.data.active ? 'Active' : 'Inactive'}
            </span>
          </div>
        );
      },
    },
  ]);

  const defaultColDef = {
    filter: false,
    sortable: true,
    floatingFilter: false,
    flex: 1,
    resizable: true,
    height: 100,
    minWidth: 100,
  };
  const onGridReady = (params) => {
    setRowData(chamberTableData);
    setGridApi(params);
  };
  const cloneShift = (values) => {
    setBtnLoading(true);

    const payload = {
      shiftId: values.id, // same as earlier shiftid
      roomId: values.roomId,
      doctorId: values.doctorId,
      cloneDate: values.chamberDate, // array of dates
      IsConfirm: false,
    };
    console.log('payload', payload);
    setLastPayload(payload);

    LdcApi({
      method: 'POST',
      url: `Chamber/CloneChamber`,
      data: payload, // send payload in body
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        if (res.data.status.isSuccess === true) {
          addToast('Clone Rota Added successfully.', { appearance: 'success' });
          setShow(false);
          getChamberList();
        } else if (
          res.data.status.errorMessage ===
          `The doctor is already booked in the same room on the same date`
        ) {
          addToast(
            `The doctor is already booked in the same room on the same date.`,
            { appearance: 'warning' }
          );
        } else if (
          res.data.status.errorMessage ===
          `The doctor is already booked on the same date but in a different room`
        ) {
          addToast(
            `The Doctor is already booked on the selected date or room.`,
            { appearance: 'warning' }
          );
        } else if (
          res.data.status.errorMessage ===
          `The room is already booked by another doctor on the same date`
        ) {
          addToast(
            `The room is already booked by another doctor on the same date.`,
            { appearance: 'warning' }
          );
        } else if (
          res.data.status.errorMessage?.includes(
            'The doctor already has bookings on some of the selected dates'
          )
        ) {
          const match = res.data.status.errorMessage.match(/\((.*?)\)/);
          if (match) {
            setConflictDates(match[1]); // "23/08/2025" or "23/08/2025, 24/08/2025"
          }
          setShowConfirmModal(true);
        } else {
          addToast(res.data.status.errorMessage || 'Something is wrong.', {
            appearance: 'error',
          });
        }
        setBtnLoading(false);
      })
      .catch((error) => {
        setShow(false);
        setBtnLoading(false);
      });
  };
  const handleConfirm = () => {
    setBtnLoading(true);

    LdcApi({
      method: 'POST',
      url: `Chamber/CloneChamber`,
      data: { ...lastPayload, IsConfirm: true }, // override IsConfirm
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        if (res.data.status.isSuccess === true) {
          addToast('Clone Rota Added successfully.', { appearance: 'success' });
          setShowConfirmModal(false);
          setShow(false);
          getChamberList();
        } else {
          addToast(res.data.status.errorMessage || 'Something is wrong.', {
            appearance: 'error',
          });
        }
        setBtnLoading(false);
      })
      .catch(() => {
        setBtnLoading(false);
        setShowConfirmModal(false);
      });
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <React.Fragment>
      <Row className='mt-3'>
        <Col>
          <Card className='p-3 '>
            <div
              className='ag-theme-alpine mt-2'
              style={{ height: '90vh', width: '100%' }}
            >
              <AgGridReact
                ref={gridRef}
                rowData={chamberTableData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={onGridReady}
                pagination={true}
                paginationPageSize={50}
                debounceVerticalScrollbar={true}
                // paginationAutoPageSize={true}
              />
            </div>
          </Card>
        </Col>
        <Modal show={show} onHide={handleClose} size='lg'>
          <Modal.Header closeButton>
            <Modal.Title>
              Clone Rota for{' '}
              <span style={{ textTransform: 'capitalize' }}>
                {modify?.doctor}
              </span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Formik
              // initialValues={modify}
              // initialValues={{
              //   ...modify,
              //   chamberDate: modify.chamberDate
              //     ? Array.isArray(modify.chamberDate)
              //       ? modify.chamberDate
              //       : [modify.chamberDate] // wrap single date in array
              //     : [getFirstAvailableDate()], // fallback empty array
              // }}
              // validationSchema={validationSchema}
              // onSubmit={cloneShift}

              enableReinitialize // important so Formik resets when initialValues change
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={cloneShift}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Row className='my-4'>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className='fw-semibold'
                          style={{ marginBottom: '0.375rem' }}
                        >
                          Dates <span className='text-danger'>*</span>
                        </Form.Label>
                        <div className='d-flex flex-column'>
                          <DatePicker
                            multiple
                            value={values.chamberDate || []}
                            onChange={(dates) => {
                              const formattedDates = dates.map((d) =>
                                d.format('YYYY-MM-DD')
                              );
                              setFieldValue('chamberDate', formattedDates);
                            }}
                            format='YYYY-MM-DD'
                            highlightToday={false}
                            calendarPosition='bottom-start'
                            className='custom-calendar'
                            containerClassName='w-100'
                            style={{
                              width: '100%',
                              padding: '18px 12px',
                              borderRadius: '4px',
                              border:
                                touched.chamberDate && errors.chamberDate
                                  ? '1px solid #dc3545'
                                  : '1px solid #ced4da',
                              backgroundColor: '#fff',
                              fontSize: '14px',
                            }}
                            placeholder='Select one or more dates'
                            mapDays={({ date }) => {
                              // Filter booked dates only for the currently selected doctor
                              const bookedDates = new Set(
                                chamberTableData
                                  .filter(
                                    (item) => item.doctorId === values.doctorId
                                  ) // only this doctor
                                  .map((item) => item.chamberDate)
                              );

                              const formatted = date.format('YYYY-MM-DD');
                              if (bookedDates.has(formatted)) {
                                return {
                                  style: {
                                    color: 'red',
                                    fontWeight: 'bold',
                                  },
                                  disabled: false, // or true if you want to prevent selecting
                                };
                              }
                            }}
                          />

                          {touched.chamberDate && errors.chamberDate && (
                            <small className='text-danger mt-1'>
                              {errors.chamberDate}
                            </small>
                          )}
                        </div>
                      </Form.Group>
                    </Col>

                    {/* <Col lg={6}>
                      <Form.Group>
                        <Form.Label>
                          Date <span className='text-danger'>*</span>
                        </Form.Label>
                        <Form.Control
                          className='m-0 p-2'
                          type='date'
                          name='chamberDate'
                          placeholder='Room Name'
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.chamberDate}
                          error={errors.chamberDate}
                          touched={touched.chamberDate}
                          //   isInvalid={touched.date && !!errors.date}
                          //   isValid={touched.date && !errors.date}
                          required
                        />
                        {touched.chamberDate && errors.chamberDate && (
                          <small className='text-danger error_field'>
                            {errors.chamberDate}
                          </small>
                        )}
                      </Form.Group>
                    </Col> */}
                    <Col lg={6}>
                      <Form.Label>
                        Room <span className='text-danger'>*</span>
                      </Form.Label>
                      <select
                        className='form-control'
                        aria-label='Default select example'
                        name='roomId'
                        type='number'
                        placeholder='Active'
                        display='Active'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.roomId}
                        error={errors.roomId}
                      >
                        {roomList.map((items, index) => (
                          <option key={index} value={items.id}>
                            {items.name}
                          </option>
                        ))}
                      </select>
                      {touched.roomId && errors.roomId && (
                        <small className='text-danger error_field'>
                          {errors.roomId}
                        </small>
                      )}
                    </Col>
                  </Row>
                  <Row className='justify-content-center'>
                    <Col lg={6}>
                      <Button
                        type='submit'
                        className='ne_btn w-100 ne_btn_primary d-flex justify-content-center align-items-center'
                      >
                        {btnLoading ? 'Loading...' : 'Submit'}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>
        <Modal
          show={showConfirmModal}
          onHide={() => setShowConfirmModal(false)}
          top
          backdrop='static'
          backdropClassName='blurred-backdrop'
          size='lg'
        >
          <Modal.Header
            closeButton
            style={{
              // borderBottom: '1px solid gray',
              paddingBottom: '16px',
            }}
          >
            <Modal.Title
              style={{
                width: '100%',
                textAlign: 'center',
                fontSize: '1.5rem',
                fontWeight: 'bold',
              }}
            >
              Confirm Action
            </Modal.Title>
          </Modal.Header>

          <Modal.Body
            style={{
              textAlign: 'center',
              paddingTop: '2rem',
              paddingBottom: '2rem',
            }}
          >
            <p
              style={{
                marginBottom: '0.75rem',
                fontSize: '1.25rem',
                color: '#333',
              }}
            >
              The doctor already has bookings on some of the selected dates
              {conflictDates && (
                <>
                  : <small style={{ color: 'red' }}>{conflictDates}</small>
                </>
              )}
              <br />
              Do you want to{' '}
              <strong style={{ fontWeight: 'bold' }}>
                skip those dates
              </strong>{' '}
              while cloning?
            </p>
          </Modal.Body>

          <Modal.Footer
            style={{
              // borderTop: "1px solid gray",
              display: 'flex',
              justifyContent: 'center',
              gap: '1rem',
              paddingBottom: '1rem',
            }}
          >
            <Button
              variant='primary'
              onClick={handleConfirm}
              style={{
                padding: '0.5rem 1rem',
                borderRadius: '6px',
                boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                fontSize: '1rem',
              }}
            >
              Yes Clone
            </Button>
            <Button
              variant='light'
              onClick={() => setShowConfirmModal(false)}
              style={{
                padding: '0.5rem 1rem',
                borderRadius: '6px',
                boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                border: '1px solid #e2e8f0',
                fontSize: '1rem',
              }}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </Row>
    </React.Fragment>
  );
};

export default ChamberTable;
